import { render, staticRenderFns } from "./workInfo.vue?vue&type=template&id=128407e2&"
import script from "./workInfo.vue?vue&type=script&lang=js&"
export * from "./workInfo.vue?vue&type=script&lang=js&"
import style0 from "./workInfo.vue?vue&type=style&index=0&id=128407e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports